import type { manage as en } from '@/i18n/locales/en/manage';
import type { Translation } from '@/i18n/types';

export const manage: Translation<typeof en> = {
  backToApp: "Torna all'app",
  sections: {
    companies: {
      label: 'Aziende',
      items: {
        companies: 'Aziende',
        pilots: 'Pilot',
      },
    },
    people: {
      label: 'Persone',
      items: {
        users: 'Tutti gli utenti',
        linkIdentities: 'Collega identità',
        admins: 'Amministratori',
      },
    },
    audit: {
      label: 'Controllo',
      items: {
        audit: 'Registro di controllo',
      },
    },
    subscriptions: {
      label: 'Abbonamenti',
      items: {
        config: 'Provider configuration',
        products: 'Prodotti e fornitori',
        userLedger: 'Registro utenti',
      },
    },
    system: {
      label: 'Sistema',
      items: {
        statistics: 'Stato statistiche e ricostruzione',
        requests: 'Richieste API',
      },
    },
    support: {
      label: 'Supporto',
      items: {
        tickets: 'Ticket',
      },
    },
    overview: {
      label: 'Panoramica',
      items: {
        overview: 'KPI',
      },
    },
  },
  placeholders: {
    statistics: {
      title: 'Stato statistiche e ricostruzione',
      note: 'Lo stato delle statistiche e i controlli di ricostruzione sono un piano a sé — questa voce di menu riserva il posto, la schermata non è realizzata nella fase 1.',
    },
  },
  usersAll: {
    title: 'Tutti gli utenti',
    linkIdentities: 'Collega identità',
    empty: 'Non esiste ancora nessuna identità.',
    name: 'Nome',
    email: 'E-mail',
    language: 'Lingua',
    login: 'Accesso',
    yes: 'sì',
    no: 'no',
    view: 'Visualizza',
    rowsLabel: 'gli utenti',
  },
  linkIdentities: {
    title: 'Collega identità duplicate',
    lead: 'L’alias continua a esistere, ma punta a quella principale. A meno che tu non sia amministratore della piattaforma, una delle due deve essere priva di accesso e l’identità con accesso diventa quella principale — il server lo verifica, qualunque cosa venga scelta qui.',
    candidatesLabel: 'le persone che amministri',
    needTwo: 'Servono almeno due persone nel tuo ambito per collegarle.',
    aliasLabel: 'Alias (questa identità diventa il puntatore)',
    primaryLabel: 'Principale (l’identità che rimane)',
    choose: 'Scegli…',
    hasLogin: '(ha accesso)',
    noLogin: '(nessun accesso)',
    link: 'Collega',
    cancel: 'Annulla',
  },
  erase: {
    completedTitle: 'Cancellazione completata',
    completedText:
      'L’identità è stata cancellata. Il registro di controllo è pseudonimizzato, non eliminato; le identità collegate sopravvivono con il puntatore reimpostato.',
    departmentsWithoutAdmin: 'Reparti rimasti senza amministratore: {{names}}',
    measurementsNotDeleted:
      'Le misurazioni nel servizio di ingest NON sono state eliminate — questa funzionalità non esiste ancora lì. Occupatene al di fuori della dashboard.',
    backToUsers: 'Torna agli utenti',
    title: 'Cancella questa persona',
    lead: 'Questo elimina in modo irreversibile e definitivo l’identità {{userId}}: la sua riga utente, le appartenenze, i consensi e le concessioni. Le identità collegate sopravvivono; i dati provenienti da Gengee restano; il registro di controllo è pseudonimizzato. Digita {{confirmWord}} per confermare.',
    confirmWord: 'CANCELLA',
    confirmationLabel: 'Conferma',
    erasePermanently: 'Cancella definitivamente',
    cancel: 'Annulla',
  },
  requests: {
    title: 'Richieste API',
    lead: 'Le richieste registrate dall’API di ingest per una sorgente, dalle più recenti, eventualmente limitate a una finestra temporale.',
    filterSource: 'Filtra per sorgente',
    sourcePlaceholder: 'id sorgente',
    filterFrom: 'Da',
    filterTo: 'A',
    filter: 'Filtra',
    enterSourceHint: 'Inserisci un id sorgente per caricare il suo registro delle richieste.',
    empty: 'Nessuna richiesta registrata per questa sorgente e finestra.',
    when: 'Quando',
    method: 'Metodo',
    path: 'Percorso',
    status: 'Stato',
    rowsLabel: 'le richieste',
  },
};
